
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7 12.763a6 6 0 100-12 6 6 0 000 12z","stroke":"#000C1F","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M3.954 7.686c.461 1.662 2.308 2.677 3.97 2.216 1.014-.37 1.845-1.2 2.122-2.216M4.97 5.286a.185.185 0 110-.369","stroke":"#000C1F","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M4.97 4.786a.5.5 0 000 1v-1zm0-.369a.5.5 0 000 1v-1zm0 1.37a.685.685 0 00.684-.685h-1c0-.175.141-.316.315-.316v1zm.684-.685a.685.685 0 00-.685-.685v1a.315.315 0 01-.315-.315h1z","fill":"#000C1F"}}),_c('path',{attrs:{"d":"M9.03 5.286a.185.185 0 110-.369","stroke":"#000C1F","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M9.03 4.786a.5.5 0 000 1v-1zm0-.369a.5.5 0 000 1v-1zm0 1.37a.685.685 0 00.685-.685h-1c0-.175.142-.316.316-.316v1zm.685-.685a.685.685 0 00-.684-.685v1a.315.315 0 01-.316-.315h1z","fill":"#000C1F"}})])
          )
        }
      }
    